import React, { useEffect } from 'react';
import styled from 'styled-components';

import { uiStore } from '../../core/stores/ui-store';
import { Header } from '../../app/components/header';

export const AnalyticsPages = () => {
  useEffect(() => {
    uiStore.pageTitle = {
      label: 'Analytics',
    };

    uiStore.showBack = false;
  }, []);

  return (
    <Page>
      <Header title="Analytics" />

      <Container>
        <Card>
          <svg
            width="209"
            height="130"
            viewBox="0 0 209 130"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M31.9632 30.8313L45.4411 24.4273C50.8323 21.964 60.4381 17.0867 68.4762 13.3435C78.524 8.66462 87.3453 15.314 105.724 29.5988C120.427 41.0267 140.44 38.6303 148.608 36.0037C149.589 36.0037 153.509 31.3239 154.245 27.383C154.98 23.4421 153.264 15.0677 156.205 9.64895C159.146 4.23022 166.987 3.73671 173.604 4.47563C180.22 5.21455 187.327 6.19977 188.307 4.47563C189.287 2.75149 195.168 0.288433 201.785 3.73671C208.401 7.18499 205.951 14.3279 203.01 17.0372C200.658 19.2047 193.861 17.9403 190.757 17.0372C186.428 17.2835 177.476 18.7614 176.299 22.7023C175.123 26.6431 175.185 27.6302 175.742 29.846C177.6 37.2352 179.73 45.8559 181.445 48.8107C182.31 50.2998 186.347 48.8107 188.797 47.0865C191.248 45.3624 195.413 45.3624 200.315 47.0865C205.216 48.8107 208.891 57.6777 205.951 66.0521C203.01 74.4265 193.943 74.1802 190.757 72.7023C187.572 71.2245 183.406 70.0148 181.445 71C179.485 71.9852 177.28 80.5841 176.299 87.2344C175.319 93.8846 163.067 100.289 160.616 102.752C158.656 104.722 139.705 113.261 130.475 117.284C129.903 117.202 126.554 118.466 117.732 124.18C106.704 131.323 104.499 126.397 104.009 125.658C103.519 124.919 101.803 120.978 105.724 114.574C109.645 108.17 116.507 107.185 117.732 107.431C118.712 107.628 122.224 106.364 123.858 105.707L141.502 89.9437C142.564 88.6301 144.05 86.0028 141.502 86.0028C138.953 86.0028 111.36 86.8238 97.8826 87.2344C84.8948 88.3838 65.5666 92.5053 62.0379 92.8994C57.6269 93.392 22.8965 91.9142 22.1613 92.8994C21.4262 93.8846 14.5647 104.968 12.359 106.939C10.1533 108.909 9.1741 108.417 4.76315 106.939C1.23439 105.757 1.82252 102.013 2.55768 100.289C5.08989 94.2951 10.5952 81.7171 12.359 79.3526C14.5637 76.3969 13.34 75.9043 17.9952 75.9043C22.6504 75.9043 37.6002 70.9782 47.8924 68.5151C58.1846 66.0521 74.3581 64.0816 79.5042 61.3722C83.6211 59.2048 84.3235 55.543 84.1602 53.9831C83.7518 51.9305 82.2488 46.6924 79.5042 42.1604C76.0734 36.4954 73.3779 36.988 71.6625 36.988C69.9471 36.988 51.5682 44.1309 49.8528 45.6087C48.1375 47.0865 46.4221 48.8107 42.5012 53.9831C39.3646 58.121 35.313 56.5282 33.6794 55.2146C27.8795 50.699 15.4957 40.7318 12.359 36.988C8.43816 32.3082 15.0546 25.4125 17.9952 24.4273C20.3477 23.6391 28.2874 28.3682 31.9632 30.8313Z"
              fill="#D53075"
              fillOpacity="0.12"
              stroke="#D53075"
              strokeWidth="2.5"
              strokeDasharray="3 3"
            />
          </svg>

          <h2>
            This page is still in development <br />
            Coming soon
          </h2>
        </Card>
      </Container>
    </Page>
  );
};

const Page = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  width: 60rem;
  max-width: 100%;
  margin: 8rem auto;
  background-color: #181a1e;
  border-radius: var(--border-radius-medium);
  padding: 4rem;
  text-align: center;
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  margin: 0 2.4rem 2.4rem 2.4rem;

  svg {
    width: 100%;
  }
`;
